import React from 'react';

export default class CordellEstimatorZones extends React.Component {
  render(props) {
    const legacySelectStyle = {
      border: '1px solid #a805fb',
      backgroundColor: '#f7efe2',
      color: 'midnightblue'
    };

    return (
      <div id='cordell-estimater-zone-panel' className='panel-body-spacing'>
        {this.props.geographyStatesSection.map(function (section, index) {
          let classNames = require('classnames');
          let zonesTileClass = classNames({
            alert: section.id !== this.props.selectedZone || this.props.selectedPackage !== 'trial',
            'alert alert-success':
              (section.id === this.props.selectedZone && section.id !== this.props.stateError) ||
              this.props.selectedPackage === 'trial',
            'alert alert-danger': section.id === this.props.stateError
          });
          return (
            <div
              className={zonesTileClass}
              key={index}
              onClick={() => {
                this.props.selectedGeographyState(
                  this.props.geographyStatesSection,
                  section,
                  index,
                  true
                );
              }}
            >
              <div className='row no-margin zone-center body'>
                <div className='col-sm-6 no-padding'>{section.state}</div>
                <div className='col-sm-4 no-padding'>
                  {section.id === 1 && section.id === this.props.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='one-state-option1'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.props.option1 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.props.selectSingleState(event.target.value, 1);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.props.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                  {section.id === 2 && section.id === this.props.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='two-state-option1'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.props.option2 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.props.selectSingleState(event.target.value, 2);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.props.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                  {section.id === 2 && section.id === this.props.selectedZone && (
                    <div className='product-config-select-wrap'>
                      <select
                        id='two-state-option2'
                        className='form-control'
                        style={legacySelectStyle}
                        value={this.props.option3 || ''}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        onChange={(event) => {
                          this.props.selectSingleState(event.target.value, 3);
                        }}
                      >
                        <option value=''>Select</option>
                        {this.props.geographyStates.map(function (state, subIndex) {
                          return (
                            <option key={subIndex} value={state}>
                              {state}
                            </option>
                          );
                        })}
                      </select>
                      <span className='caret product-config-caret'></span>
                    </div>
                  )}
                </div>
                <div className='col-sm-2 font-14 text-right no-padding'>
                  {section.price !== '+$0.00' && section.price !== 'Selected' && (
                    <span>{section.price}</span>
                  )}
                </div>
              </div>
            </div>
          );
        }, this)}
        <div className='row no-margin body light-blue-bg padding-15 vertical-align'>
          <div
            className='col-sm-6 heading2'
          >
            National Data
          </div>
          <div
            className='col-sm-6 clear-text-deco contact-text'
          >
            <a
              id='contact-btn'
              type='button'
              className='btn package-btn'
              href='https://www.cotality.com/au/products/cordell-estimator#rc-form'
              style={{marginTop: '0px'}}
            >
              Request Pricing
            </a>
          </div>
        </div>
      </div>
    );
  }
}
